import { SlotGameType1_2 } from "../SlotGameType1_2";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
// import { SetStyles } from "../.././MyHelpers";
import { SetStyles } from "../.././MyHelpers";
import { FontResource } from "../../ResourceManager/FontResource";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
// namespace SlotGames2
// {
	export class RainbowTreasure2 extends SlotGameType1_2
	{
   
		//protected override freegameBonusFactory: FreegameBonusFactory2 = new RainbowMagicFreegame2BonusFactory();
		// 	public override TitleLoaded(resourceManager:ResourceManager)
		// {
		// 	super.TitleLoaded(resourceManager);

		// 	SetStyles(this.view.querySelector(".title"),
		// 	{
		// 		display:"flex",
		// 		justifyContent:"center",
		// 		margin:"26px",
		// 		//backgroundSize:"contain"


		// 	});
		// 	this.titleSprite.Scale(1.5);
		// }

        protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
        {
        	super.PaytableLoaded(resourceManager);
        	SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
			{
				//HIDE BACKGROUND COLOR
				//backgroundColor:"rgba(0, 0, 0, 0.6)",
			});


        }
		
		public override PrepareFont(resourceManager: ResourceManager)
		{
			resourceManager.Add(new FontResource(this.basepath + "resources/AXR Neverland Shadow.ttf", "." + this.resid.ScopedResourceName(["font"])));
		}
	}
	
// }
